import React from 'react'
import { Info } from 'lucide-react'

type ToastProps = {
  message: string
}

const Toast: React.FC<ToastProps> = ({ message }: ToastProps) => {
  return (
    <div
      id="wl-custom-toast"
      className="animate-slide-in fixed bottom-4 right-4 z-50"
    >
      <div className="flex items-center gap-3 rounded-md bg-gray-900 px-4 py-3 text-white shadow-lg">
        <Info className="text-lg text-white" />
        <p className="text-sm capitalize">{message}</p>
      </div>
    </div>
  )
}

export { Toast }
